import { createContext, useContext, useRef, useState, useEffect } from 'react'

const SelectionContext = createContext()

export const SelectionProvider = ({ children }) => {
  const selectionRef = useRef('statement')
  const [, forceUpdate] = useState({})
  
  const setSelection = (value) => {
    selectionRef.current = value
    forceUpdate({})
  }
  
  return (
    <SelectionContext.Provider value={{ 
      selection: selectionRef.current, 
      setSelection 
    }}>
      {children}
    </SelectionContext.Provider>
  )
}

export const useSelection = () => useContext(SelectionContext)

export default SelectionProvider